exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width: 1024px){.mobile-only{display:none !important}}@media (max-width: 1023px){.desktop-only{display:none !important}}.sf-link{color:var(--link-color, var(--c-text));font:var(--link-font, var(--link-font-weight, var(--font-normal)) var(--link-font-size, var(--font-lg))/var(--link-font-line-height, 1.4) var(--link-font-family, var(--font-family-secondary)));-webkit-text-decoration:var(--link-text-decoration, underline);text-decoration:var(--link-text-decoration, underline)}.sf-link:visited{color:var(--link-color)}.sf-link:hover{color:var(--link-color)}\n", ""]);

// exports
